/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import SignupCollectionAction from '../SignupCollectionAction';
import HomeAddressCollection from '../HomeAddressCollection';
import { setFormData } from '../../../actions/collection';
import HomeApi from '../../../api/Home';
import i18n from '../../../i18n';
import withAnalytics from '../../analytics/withAnalytics';
import CollectionFunnelEvents from '../../../utils/collectionFunnelEvents';

export const Step3Collection = (props) => {
    const [canContinue, setCanContinue] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const navigate = useNavigate();

    const onChange = (address, gid) => {
        if (address) {
            props.setFormData({
                ...props.formCollectionData,
                address,
                location_id: gid,
                provider: 'Jawg'
            });
        }
        setCanContinue(!_.isEmpty(address));
    };

    const hasError = (error) => {
        setCanContinue(Boolean(!error));
    };

    const submitForm = () => {
        if (props.formCollectionData && !_.isEmpty(props.formCollectionData.address)) {
            setIsSending(true);
            HomeApi.addHomeCollection(props.formCollectionData).then(
                () => {
                    navigate(location.pathname.replace(/[^/]*$/, 'step4'));
                    CollectionFunnelEvents.funnelProgress(3);
                    props.track('HEC Home init', { category: 'HEC application' });
                },
                (error) => {
                    setIsSending(false);
                    console.error(error);
                }
            );
        }
    };

    useEffect(() => {
        if (_.isEmpty(props.formCollectionData)) {
            HomeApi.getHomeCollection().then((response) => {
                if (response) {
                    setCanContinue(!_.isEmpty(response.address));
                    props.setFormData(response, () => {
                        navigate(location.pathname.replace(/[^/]*$/, 'step2'));
                    });
                }
            });
        }
    }, []);

    return (
        <>
            <div className="step3-container">
                <div className="step-circle">
                    <span>3</span>
                </div>
                <div className="step-title">
                    <h2>{i18n.t('collection:step_3_collection_title')}</h2>
                </div>
                <HomeAddressCollection
                    submitForm={submitForm}
                    updateData={onChange}
                    addressHome={props.formCollectionData ? props.formCollectionData.address : ''}
                    hasError={hasError}
                />
            </div>
            <SignupCollectionAction step={3} isValid={canContinue} isSending={isSending} />
        </>
    );
};

Step3Collection.propTypes = {
    formCollectionData: PropTypes.object,
    setFormData: PropTypes.func,
    track: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
    setFormData: bindActionCreators(setFormData, dispatch)
});

const mapStateToProps = (state) => ({
    formCollectionData: state.collection.formCollection
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withAnalytics)(Step3Collection);
